import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        OneTimePassword: '',
        TwoFactorAuthenticationSecret: null,
        QRCode: null,
    },

    actions: {
        verify({ state }) {
            return axios.post('/2fa', {
                OneTimePassword: state.OneTimePassword,
            });
        },
        setup({ state }) {
            return axios.post('/api/2fa/setup', {
                OneTimePassword: state.OneTimePassword,
                TwoFactorAuthenticationSecret: state.TwoFactorAuthenticationSecret,
            });
        },
        getSecret({ commit }) {
            return axios.get('/api/2fa/secret')
            .then((response) => {
                commit('setSecret', response.data.TwoFactorAuthenticationSecret);
                commit('setQRCode', response.data.QRCode);
            });
        },
    },

    mutations: {
        updateField,
        setSecret(state, TwoFactorAuthenticationSecret) {
            state.TwoFactorAuthenticationSecret = TwoFactorAuthenticationSecret;
        },
        setQRCode(state, QRCode) {
            state.QRCode = QRCode;
        },
    },

    getters: {
        getField,
    },
};
